import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=19fbf4b2"
import script from "./Row.vue?vue&type=script&setup=true&lang=js"
export * from "./Row.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports